import React from 'react'
import SectionsLayout from './SectionsLayout'

const Sections = () => {
  return <SectionsLayout />
}
export default Sections
